import OlMap from "ol/Map";
import { ScaleLine as OlScaleLine } from "ol/control";
import { Units } from "ol/control/ScaleLine";

import { useState } from "react";
import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

const ScaleUnitPopup = new Popup({
	title: () => getLocaleString("scaleunits"),
	style: {maxWidth: 550},
	distinct: true,
	render: function() {
		const map:OlMap = this.get("map");
		const scaleLine:OlScaleLine = map.get("scale-line");
		const options:Array<string> = this.get("unit-options");
			
		const [currentUnit, setCurrentUnit] = useState<Units>(scaleLine.getUnits());
			
		const selectUnit = (unit:Units) => {
			scaleLine.setUnits(unit);
			setCurrentUnit(unit);
			
			// Set the units of the scale line on the global UI for easy reference elsewhere
			_ui.setScaleLineUnits(unit);
			
			// Delay close for the satisfaction of the selected unit turning grey :P
			setTimeout(() => _ui.closePopupOf(this), 100);
		}
		const drawOptions = () => {
			const rows:Array<any> = [];
			
			options.forEach((unit:string) => {
				let className:string = "unit-option";
				
				if(currentUnit == unit)
					className += ` unit-option--selected ${_ui.getSelClassName()}`;
				
				rows.push(
					<div 
						className={className} 
						key={options.indexOf(unit)} 
						onClick={() => selectUnit(unit as Units)}
					>
						{getLocaleString(`unit-${unit}`)}
					</div>
				);
			});
			
			return rows;
		}
		
		return (
			<>
				{drawOptions()}
			</>
		)
	}
});

export default ScaleUnitPopup;